<template>
  <el-dialog :title="title" :visible.sync="dialogFormVisible"   style="width:600px; margin:auto;" @close="close" :close-on-click-modal="false">
    <el-form ref="form" :model="form" :rules="rules" label-width="90px" v-loading="loading" :element-loading-text="elementLoadingText">
       <div style="max-height:600px;overflow-y: auto;">
        <el-row v-for="(item,index) in form.items" :key="index" :style="index>0?'padding-top:10px;':''">
            <el-col :span="5">            
              <div class="el-input" style="width:80px; height:80px;">
                <img :src="item.productImage" style="width:100%" />
              </div>  
            </el-col>
            <el-col :span="19" style="padding-top:10px;font-size:18px;">           
              {{item.productName}}    
              <div style="margin-top:10px;color:#FF5E00 !important;">
               <div style="float:left;width:55px;font-size:16px;"> 评分：</div><div style="width:70%;"> <el-rate v-model="item.score"></el-rate></div>
              </div>
            </el-col>  
            <div style="background-color: #F4F4F4;padding:5px; clear: both;min-height:200px;">  
              <div>图片和文字可以帮助其他人更好地了解商品</div>
              <el-col :span="24">
                <el-input type="textarea" :rows="4" placeholder="" v-model="item.evaluateContent"></el-input>
              </el-col>   
              <el-col  v-for="(item1, index1) in item.evaluatePictures" :key="index1" :span="4" style="margin:5px 0px;">   
                <div style="width: 65px; height: 65px;float:left;">
                  <img v-if="item1" :src="item1" style="height: 65px;width: 65px;"/>  
                </div>          
                <i class="el-icon-delete" style="float: left;" @click="removeMedia(index, index1)"></i>
              </el-col>  
              <el-col :span="4"  style="margin:5px 0px; ">          
                <el-upload
                  :action="aLiction" 
                  :http-request="uploadALiFile"
                  :before-upload="(file) => beforeAvatarUpload(file, index)"
                  class="avatar-uploader"
                  :show-file-list="false"
                  multiple            
                >
                <i class="el-icon-plus avatar-uploader-icon" style="border:1px solid #FF5E00; width:70px;height:70px;line-height:70px;font-size:20px;color:#FF5E00"></i>
                </el-upload>
              </el-col>  
            <div style="clear: both;"></div>
            </div>
          </el-row>      
        </div>            
    </el-form>
    <div slot="footer" class="dialog-footer">
      <span style="margin-right:10px;"><el-checkbox v-model="form.isAnonymous">是否匿名</el-checkbox></span>
      <el-button class="closeBtn"  @click="close">取 消</el-button>
      <el-button class="saveBtn" type="primary" @click="validateData">确 定</el-button>
    </div>    
  </el-dialog>
</template>

<script>
import store from '@/store'
import { evaluate } from '@/api/order'
import { getALiUploadToken,uploadALiFile } from '@/api/commonLookup'
import axios from 'axios'
export default {
  name: 'OrderEvaluate',
  components: {  },
  data() {
    return {     
      form: { 
        orderId:0,
        isAnonymous:false,
        items:[]
      },
      uploadIndex:0,
      rules: { },       
      title: '',
      dialogFormVisible: false,
      loading:false,
      elementLoadingText:"数据提交中,请稍后...",     
      aLiction:''       
    }
  },
  methods: {
    async showEvaluate(row) {  
      this.title = '评价'     
      this.form.orderId = row.id;
      this.form.items = [];
      for(var i=0;i<row.ordersDetials.length;i++)
      {
        var temp = row.ordersDetials[i];
        var item = {
          orderItemId:temp.id,
          score:0.00,
          evaluateContent:'',
          evaluatePictures:[],
          productImage:temp.defaultImage,
          productName:temp.pName,
          productPrice:temp.price
        };
        this.form.items.push(item);        
      }
      this.dialogFormVisible = true
    },     
    beforeAvatarUpload(file,index) {
        this.uploadIndex=index;
        const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
        const isLt2M = file.size / 1024 / 1024 < 20;
        if (!isJPG) {
          this.$message.error('上传头像图片只能是 JPG/PNG 格式!');
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 20MB!');
        }
        return isJPG && isLt2M;
      },      
      removeMedia(i,j)
      {
        this.form.items[i].evaluatePictures.splice(j, 1)
        this.$message.success('移除成功');
      },
    //上传文件到阿里
    async uploadALiFile(upload) {                    
      this.uploadFileALi(upload)
    },
    async uploadFileALi(upload)
    {      
      this.loading=true;
      var _this=this;
      await getALiUploadToken().then(ret => {        
        debugger;   
        if(ret.data&& ret.data.success)
        {
          var tempRes = ret.data.result;
          this.aLiction=  tempRes.host;
          this.loading = true;      
          const formData = new FormData() // 创建FormData对象     
          let arrB= upload.file.name.split('.');
          let suffix = '.' + arrB[arrB.length-1];  
          var filename = "s" + this.guidShort() + suffix;           
          var tempMediaType=0;
          if(suffix.indexOf('mp4')>-1||suffix.indexOf('MP4')>0)tempMediaType=1;
          var url = tempRes.aliDomain + tempRes.dir + filename;
          try{        
          // 添加相关上传参数
            formData.append('key', tempRes.dir + filename);
            formData.append('policy', tempRes.policy);
            formData.append('OSSAccessKeyId', tempRes.accessid);
            formData.append('success_action_status', '200');
            formData.append('signature', tempRes.signature);         
            formData.append('file', upload.file) 

            uploadALiFile(this.aLiction, formData).then((res) => {              
              _this.loading = false
                if(res.status==200)
                {                  
                  this.form.items[ this.uploadIndex].evaluatePictures.push(url);
                  this.$message.success('上传成功!')                    
                }
             }).catch((err) => { 
              debugger;
              _this.loading = false
             })          
          }
          catch(ex) { debugger; }
        } 
        else{ 
           this.loading=false;
           this.$message.error('获取阿里token失败!') 
           }
      }) 
    },
     //GUID生成
     guidShort() {
        function S4() {
            return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
        }
        return (S4() + S4() + "" + S4() + "" + S4() + "" + S4() + "" + S4() + S4() + S4());
    },
    close() {    
      this.$refs['form'].resetFields()
      this.$emit('fetch-data')
      this.form = this.$options.data().form      
      this.dialogFormVisible = false
    },
    validateData()
    {
      if(this.form.orderId==null||this.form.orderId==0||this.form.orderId==undefined)
      {
        this.$message.error('未能找到评价的订单!')
        return
      }           
      this.save();         
    },
    save() {    
      this.loading=true;
      this.elementLoadingText="数据提交中,请稍后..."
      var _this=this;
      this.$refs['form'].validate(async (valid) => {    
        if (valid) { 
          await evaluate(this.form).then(res=>{       
            _this.loading=false;   
            if(res&&res.data&&res.data.success==true)
            {
              _this.$message({ message: "评价成功", type: 'success', customClass: 'c-msg' })
              _this.$refs['form'].resetFields()
              _this.$emit('fetch-data')
              _this.dialogFormVisible = false     
              _this.form = this.$options.data().form
            }    
            else
            {
               var msg='评价失败';
               if(res&&res.data&&res.data.error&&res.data.error.message)
               {
                  msg += ',原因:'+res.data.error.message;
               }
               this.$message({ message: msg, type: 'error', customClass: 'c-msg' })
            }
          })
        } else {
          _this.loading=false;
          return false
        }
      })
    },  
 
  },
}
</script>
<style>
.saveBtn
{
  background-color: #FF5E00 !important;
  border-color: #FF5E00 !important;
  color: #FFF !important;
  cursor: pointer !important;
}
.closeBtn
{
  border-color: #FF5E00 !important;
  color:#FF5E00 !important;
  cursor: pointer !important;
}
 .el-dialog__title
{
  font-size: 18px !important;
  color:#FF5E00 !important;
}


</style>


// WEBPACK FOOTER //
// OrderEvaluate.vue?907f86cc